export const pageLoaders = {
  '/': () => import('../features/home/HomePage'),
  '/calculate': () => import('../features/calculator'),
  '/stains': () => import('../features/stains'),
  '/guide': () => import('../features/guide'),
  '/teacher': () => import('../features/teacher/TeacherArea'),
};
export function preloadPage(path: string) {
  const load = pageLoaders[path as keyof typeof pageLoaders];
  if (load) void load().catch(() => undefined);
}
